import { publicApiAuthScopeSchema } from "@redotech/redo-public-common/public-api-auth";
import * as z from "zod";
import { apiTokenSchema } from "./types";

export const createApiToken = {
  name: "createApiToken" as const,
  input: z.object({
    name: z.string().min(1),
    scopes: z.array(publicApiAuthScopeSchema),
  }),
  output: z.object({
    token: apiTokenSchema,
    /** Plaintext token secret — returned exactly once, at creation time. */
    secret: z.string(),
  }),
};
